<style>
  .info{
    font-size:18px;
    margin:0 2em;
  }
  .info table{
    width:90%;
  }
  .info table th{
    border:solid 1px #ccc;
    background-color:#EEE;
  }
  .info table td{
    border:solid 1px #ccc;
  }
</style>
<template>
  <div class="info" v-html="contentHtml">
  </div>
</template>
<script>
import { getFileName, getFileExp } from 'utils/getFileInfo.js'
const HLS = require('hls.js')
export default {
  name: 'practiceInfo',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hls: null,
      getFileName,
      getFileExp
    }
  },
  computed: {
    contentHtml () {
      if (!this.content) return ''
      let html = this.content.replace(/src=['"][^http]([^'"]+)[^>]/g, `src="${this.$resBasePath}/$1"`)
      html = html.replace(/<video.*?src=[\\"|\\']?(.*?)[\\"|\\']?\s.*?><\/video>/g, '<video controls style="width:50%" controlslist="nodownload" src="$1">点击查看视频</video>')
      return html
    }
  },
  methods: {
    initHlsVideo (target, source) {
      if (HLS.isSupported()) {
        this.hls = new HLS()
        this.hls.loadSource(source)
        this.hls.attachMedia(target)
        this.hls.on(HLS.Events.ERROR, (event, data) => {
          // this.$message.error('视频加载失败！')
        })
      }
    },
    getAllHlsVideos () {
      const videos = this.$doc.querySelectorAll('video')
      videos.forEach(video => {
        if (this.getFileExp(video.getAttribute('src')) === 'm3u8') {
          this.initHlsVideo(video, video.getAttribute('src'))
        } else if (this.getFileExp(video.getAttribute('src')) === 'mp4') {
          video.src = video.getAttribute('src').replaceAll('?isPlay=1', '') + '?isPlay=1'
        }
      })
    }
  },
  mounted () {
    this.getAllHlsVideos()
  }
}
</script>
